import React, { Component } from 'react';
import { Button, Table, Segment, Header, Form, List, Dimmer, Loader }
	from 'semantic-ui-react'
//import Search from '../components/search';
import store from '../store/downloaddata-store';
import {observer} from 'mobx-react';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import ReactTable from "react-table";
import * as mobx from 'mobx';


class DownloadData extends Component {

  constructor(props) {
  	super(props);
  	this.state = {
  		visible: false
  	}
  }

  componentDidMount() {
  	store.loadAllDocs();
  	store.getOrgEmail();
   }

  toggleVisibility = () => this.setState({ visible: !this.state.visible })

  handleChange = (e, { value }) => this.setState({ value })

  showData = (section) => {
    if (section==='all') {
    	store.loadAllDocs();
    } else if (section==='currwk') {
    	store.loadCurrWkDocs();
    } else if (section==='prevwk') {
    	store.loadPrevWkDocs();
    } else if (section==='currmon') {
    	store.loadCurrMonDocs();
    }
    else if (section==='prevmon') {
    	store.loadPrevMonDocs();
    }
  }


  renderAllDoc() {
		const docs = mobx.toJS(store.filteredDocs);

		return(
				<ReactTable
					data={docs}
					noDataText="No records found"
					 //filterable
         			 //defaultFilterMethod={(filter, row) =>
           			 //String(row[filter.id]) === filter.value}
					columns = {[
						{ Header: "Document Name", accessor: "docname", Cell: props => {
							const { original } = props;
							return (<Link to={"/docdetail/" + original.docid}>{original.docname}</Link>)
						 }
						},
						{ Header: "Description", accessor: "docdescr" },
						{ Header: "Tags", accessor: "tag" },
						{ Header: "Creation Date", accessor: "creationdate" },
						{ Header: "Created By", accessor: "createdby" },
					]}
					style={{
						height: '80vh'
					}}
					defaultPageSize={25}
					//className="-striped -highlight"
					showPaginationTop={true}
					showPaginationBottom={false}
				/>
			   )
	} // renderAllDoc end



  render() {
  	const { visibleSection } = this.state;
        return(
	            <div className="user-actions">

	                <div className="title">
	                   <h4 align="left">Document List</h4>
	                </div>

	                <div>
		                <div className="header">
		                <button class="ui green button"
		                 onClick={() => this.showData('all')}>All Documents
		                </button>
		                <button class="ui blue button"
	                     onClick={() => this.showData('currwk')}>Current Week
	                    </button>
	                    <button class="ui pink button"
	                     onClick={() => this.showData('prevwk')}>Previous Week
	                    </button>
	                    <button class="ui orange button"
	                     onClick={() => this.showData('currmon')}>Current Month
	                    </button>
	                    <button class="ui purple button"
	                     onClick={() => this.showData('prevmon')}>Previous Month
	                    </button>
	     				</div>
	     				{this.renderAllDoc()}

	                </div>

            		 {store.loading && (
				          <Segment>
				            <Dimmer active inverted>
				              <Loader inverted>Loading</Loader>
				            </Dimmer>
				          </Segment>
				      )}

	            </div>
              )

          } // render() end

} // Class end

export default observer(DownloadData);





// WEBPACK FOOTER //
// ./src/containers/DownloadData.js